<template>
  <div>
    <!--    搜索部分-->
    <el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="运营中心">
        <el-input placeholder="请选择" v-model="enquiryForm.operation_center_name" size="medium" :disabled="true">
          <el-button slot="append" @click="handleSearchUser('yy')">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="所属">
        <el-input placeholder="请选择所属上级" v-model="enquiryForm.parent_name" size="medium" :disabled="true">
          <el-button slot="append" @click="handleSearchUser('su')">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="所属身份">
        <el-select v-model="enquiryForm.parent_role_type" medium clearable placeholder="请选择所属身份">
          <el-option v-for="(item, index) of role_type" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下单人">
        <el-input placeholder="请选择所属上级" v-model="enquiryForm.user_name" size="medium" :disabled="true">
          <el-button slot="append" @click="handleSearchUser('user')">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="下单人身份">
        <el-select v-model="enquiryForm.user_role_type" medium clearable placeholder="请选择所属身份">
          <el-option v-for="(item, index) of role_type" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单号码">
        <el-input size="medium" clearable v-model="enquiryForm.order_id" placeholder="请输入订单号码"></el-input>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="enquiryForm.order_status" medium clearable placeholder="请选择订单状态">
          <el-option label="未发货" value="10"></el-option>
          <el-option label="发货中" value="20"></el-option>
          <el-option label="待收货" value="30"></el-option>
          <el-option label="已完成" value="40"></el-option>
          <el-option label="已取消" value="50"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="配送方式">
        <el-select v-model="enquiryForm.delivery_type" medium clearable placeholder="请选择配送方式">
          <el-option label="快递" value="0"></el-option>
          <el-option label="自提" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间" style="width: 590px;margin-right: 40px">
        <el-date-picker v-model="enquiryForm.order_time" type="daterange" range-separator="至" start-placeholder="选择开始日期"
          end-placeholder="选择截止日期" value-format="yyyy-MM-dd" @change="pickerChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发货时间" style="width: 590px;margin-right: 40px">
        <el-date-picker v-model="enquiryForm.delivery_time" type="daterange" range-separator="至"
          start-placeholder="选择开始日期" end-placeholder="选择截止日期" value-format="yyyy-MM-dd" @change="deliveryChange">
        </el-date-picker>
      </el-form-item>
    </el-form>

    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium" style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium" type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
    </div>
    <!-- //打印 -->
    <prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
    <!--    表格部分-->
    <el-table :data="tableData" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }"
      v-loading="loading" border id="tableDataId" size="mini">
      <el-table-column header-align="center" align="center" prop="org_name" label="运营中心"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="parent_user_name" label="所属"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="parent_user_role" label="所属身份"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="user_name" label="下单人"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="user_role" label="下单人身份"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="order_id" label="订单号"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="merch_name" label="商品名称"></el-table-column>
      <el-table-column header-align="center" align="center" prop="price" label="商品单价"></el-table-column>
      <el-table-column header-align="center" align="center" prop="order_amount" label="金额"></el-table-column>
      <el-table-column header-align="center" align="center" prop="coin" label="积分"></el-table-column>
      <el-table-column header-align="center" align="center" prop="order_express_amount" label="快递费"></el-table-column>
      <el-table-column header-align="center" align="center" prop="stock" label="下单数量"></el-table-column>
      <el-table-column header-align="center" align="center" prop="pos_num" label="发货数量"></el-table-column>
      <el-table-column header-align="center" align="center" prop="order_status" label="订单状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.order_status.value == '10'" type="info" disable-transitions>
            {{ scope.row.order_status.text }}</el-tag>
          <el-tag v-if="scope.row.order_status.value == '20'" disable-transitions>
            {{ scope.row.order_status.text }}</el-tag>
          <el-tag v-if="scope.row.order_status.value == '30'" type="warning" disable-transitions>
            {{ scope.row.order_status.text }}</el-tag>
          <el-tag v-if="scope.row.order_status.value == '40'" type="success" disable-transitions>
            {{ scope.row.order_status.text }}</el-tag>
          <el-tag v-if="scope.row.order_status.value == '50'" type="danger" disable-transitions>
            {{ scope.row.order_status.text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="delivery_type" label="配送方式">
        <template slot-scope="scope">
          {{ scope.row.delivery_type.text }}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="payment_type" label="支付类型">
        <template slot-scope="scope">
          {{ scope.row.payment_type.text }}
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="create_time" label="下单时间"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="address" label="收货地址"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="delivery_order" label="发货订单号"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="delivery_from" label="物流商"></el-table-column>
      <el-table-column header-align="center" align="center" prop="delivery_person" label="发货人"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="delivery_time" label="发货时间"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column header-align="center" align="center" prop="order_remark" label="订单说明"></el-table-column>
      <el-table-column fixed="right" header-align="center" align="center" label="操作" min-width="200">
        <template slot-scope="scope" style="text-align: center;">
          <el-button type="text" @click="thawInfo(scope.row)" >下拨</el-button>
          <el-button type="text" @click="frozenInfo(scope.row)" v-if="scope.row.order_status.value == '20'">发货
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页部分 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :page-sizes="[20, 50, 100, 200, 500, 1000]" :page-size="page_size" :total="total"
      layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
    <!--    发货表单部分-->
    <el-dialog title="发货" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item label="物流商" :label-width="formLabelWidth" prop="delivery_from">
          <el-input v-model="form.delivery_from" autocomplete="off" placeholder="请输入物流商" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="物流订单号  " :label-width="formLabelWidth" prop="delivery_order">
          <el-input v-model="form.delivery_order" autocomplete="off" placeholder="请输入物流订单号"
            style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="订单说明  " :label-width="formLabelWidth">
          <el-input v-model="form.order_remark" autocomplete="off" placeholder="请输入订单说明" style="width: 600px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearShipment">取 消</el-button>
        <el-button type="primary" @click="confirmShipment('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <!--    下拨表单部分-->
    <el-dialog title="下拨" :visible.sync="dialogDownVisible">
      <el-form :model="downForm" :rules="downRules" ref="ruleForm2">
        <el-form-item label="开始终端号" :label-width="formLabelWidth" prop="start_device_code">
          <el-input v-model="downForm.start_device_code" autocomplete="off" placeholder="请输入开始终端号"
            style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="结束终端号  " :label-width="formLabelWidth" prop="end_device_code">
          <el-input v-model="downForm.end_device_code" autocomplete="off" placeholder="请输入结束终端号"
            style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="台数  " :label-width="formLabelWidth" prop="transfer_quantity" :disabled="true">
          <el-input v-model="downForm.transfer_quantity" autocomplete="off" placeholder="台数自动获取" :disabled="true"
            style="width: 600px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearShipment2">取 消</el-button>
        <el-button type="primary" @click="confirmShipment2('ruleForm2')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 选择用户信息组件 -->
    <selectAgentUser :agentVisible="agentVisible" :ident="ident" @changeAgentVisible="changeAgentVisible"
      @setSelectAgent="setSelectAgent" />
  </div>
</template>

<script>
import { export_json_to_excel } from "@/excel/Export2Excel";
import prints from '@/components/print.vue'
import selectAgentUser from './components/selectAgentUser.vue'

export default {
  name: "orderInquiry",//商品订单查询页面
  components: {
    prints,
    selectAgentUser,
  },
  data() {
    return {
      // 主页面部分
      loading: true, //列表loadding
      page_size: 20, //条数
      total: 0, //总数
      tableData: [], //表格数据
      enquiryForm: {
        page_size: 20,
        page: 1,
        operation_center: '',  //运营中心
        operation_center_name: '', //运营中心显示名称 
        parent_id: '', //所属
        parent_name: '', //所属上级显示名称
        parent_role_type: '', //所属身份
        user_id: '', //下单人
        user_name: '', //下单人名称
        user_role_type: '', //下单人身份
        order_id: '', //订单号
        order_status: '', //订单状态
        start_time: '', // 下单开始时间
        end_time: '', //下单结束时间 
        delivery_start_time: '', //发货开始时间
        delivery_end_time: '', //发货结束时间
      },
      //所属上级,下单人身份 
      role_type: {
        1: "运营中心",
        2: "金牌盟友",
        3: "盟友"
      },
      userid: '', //修改推广码当前行user_id
      // 表单部分
      loading1: true, //列表loadding
      page_size1: 20, //表单条数
      dialogTotal: 0, //表单总数
      dialogData: [], //表单数据
      dialogCodeVisible: false, //邀请码表单页面显示
      agentVisible: false, //筛选用户表单页面显示 
      dialogForm: { //表单搜索数据
        page_size: 20,
        mobile_phone: "", //手机号码
        page: 1,
        user_name: "", //用户名称
      },
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [],
      // 产品名称表单部分
      loading2: true, //列表loadding
      page_size2: 20, //表单条数
      dialogTotal2: 0,  //表单总数
      dialogData2: [],//表单数据
      dialogForm2: {//表单搜索数据
        page_size: 20,
        page: 1,
      },
      //   当前选择的行的id
      templateSelection2: "",
      //   当前选择的行的数据
      checkList2: [],

      //发货部分
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        id: '',//
        delivery_from: "",//物流商
        delivery_order: "",//物流订单号
        order_remark: ""//订单说明
      },
      formLabelWidth: '120px',
      rules: {
        delivery_from: [
          { required: true, message: '请输入物流商', trigger: 'blur' },
        ],
        delivery_order: [
          { required: true, message: '请输入物流订单号', trigger: 'blur' }
        ]
      },
      //下拨部分
      dialogTableVisible2: false,
      dialogDownVisible: false,
      downForm: {
        start_device_code: "",
        end_device_code: "",
        transfer_quantity: '',//台数
        user_id: '',//	用户ID
        transfer_type: 10,//调拨类型（10-下拨','-20-回拨）
        order_id: ''//订单id
      },
      downRules: {
        start_device_code: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        end_device_code: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        transfer_quantity: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      ident: null, //筛选标识 
      //打印
      tableTh: null,
      tableTd: null,
    }
  },
  created() {
    this.getData(this.enquiryForm)
    this.tableTh = ['运营中心', '所属', '所属身份', '下单人', '下单人身份', '订单号', '商品名称', '商品单价', '金额', '积分', '快递费', '下单数量', '发货数量', '订单状态',
     '配送方式','支付类型','下单时间', '收货地址', '发货订单号', '物流商', '发货人', '发货时间', '订单说明'];
    this.tableTd = ['org_name', 'parent_user_name', 'parent_user_role', 'user_name', 'user_role', 'order_id',
      'merch_name', 'price', 'order_amount', 'coin', 'order_express_amount', 'stock', 'pos_num', 'order_status_text',
      'delivery_type_text','payment_type_text',
      'create_time', 'address', 'delivery_order', 'delivery_from', 'delivery_person', 'delivery_time', 'order_remark'];
    this.$nextTick(() => {
      this.$refs.prints.prints();
    })
  },
  methods: {
    //打印
    printEvent() {
      this.tableData.forEach(item => { //实名状态转换文本
        item.order_statusText = item.order_status.text;
      });
      this.$nextTick(() => {
        this.$refs.prints.prints();
        this.$refs.prints.print();
      })
    },
    pickerChange(DateArr) { //下单时间-时间选择器
      this.enquiryForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
      this.enquiryForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
    },
    deliveryChange(DateArr) { //发货时间-时间选择器
      this.enquiryForm.delivery_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
      this.enquiryForm.delivery_end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
    },
    // 主页面部分
    //搜索
    handleSearch(searchForm) {
      searchForm.page = 1;
      this.getData(searchForm);
    },
    //重置
    Reset(searchForm) {
      searchForm.page_size = 20,
        searchForm.page = 1,
        searchForm.operation_center = '',  //运营中心
        searchForm.operation_center_name = '',  //运营中心 
        searchForm.parent_id = '', //所属
        searchForm.parent_name = '', //所属
        searchForm.parent_role_type = '', //所属身份
        searchForm.user_id = '', //下单人
        searchForm.user_name = '', //下单人
        searchForm.user_role_type = '', //下单人身份
        searchForm.order_id = '', //订单号
        searchForm.order_status = '', //订单状态
        searchForm.start_time = '', // 下单开始时间
        searchForm.end_time = '', //下单结束时间 
        searchForm.delivery_start_time = '', //发货开始时间
        searchForm.delivery_end_time = '', //发货结束时间
        searchForm.order_time = '',
        searchForm.delivery_time = '',

        this.getData(searchForm);
    },
    //分页
    handleCurrentChange(page) { //当前选中页
      this.enquiryForm.page = page;
      this.getData(this.enquiryForm);
    },
    handleSizeChange(limit) { //条数
      this.enquiryForm.page_size = limit;
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    //获取数据
    getData(params) { //初始化数据
      this.loading = true;
      this.$api.post("/api/order/orderList?page=" + params.page, params, res => {
        if (res.status == 200) {
          let tableData = res.data;
          this.total = tableData.total; //总数
          this.tableData = tableData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading = false;
      })
    },

    // 导出
    exportData() {

      let th = ['运营中心', '所属', '所属身份', '下单人', '下单人身份', '订单号', '商品名称', '商品单价', '金额', '积分', '快递费', '下单数量', '发货数量', '订单状态',
      '配送方式','支付类型', '下单时间', '收货地址', '发货单号', '物流商', '发货人', '发货时间', '订单说明'];
      let excelData = ['org_name', 'parent_user_name', 'parent_user_role', 'user_name', 'user_role', 'order_id',
        'merch_name', 'price', 'order_amount', 'coin', 'order_express_amount', 'stock', 'pos_num', 'order_statusText',
        'delivery_type_text','payment_type_text',
        'create_time', 'address', 'delivery_order', 'delivery_from', 'delivery_person', 'delivery_time', 'order_remark'];
      this.tableData.forEach(item => { //实名状态转换文本
        item.order_statusText = item.order_status.text;
        item.delivery_type_text = item.delivery_type.text;
        item.payment_type_text = item.payment_type.text;
      });
      let data = this.formatJson(excelData, this.tableData);
      let defaultTitle = '导出文件';
      export_json_to_excel(th, data, defaultTitle)
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 表单部分
    //表单分页
    handleCurrentChange1(page) { //当前选中页
      this.dialogForm.page = page;
      this.getDialogData(this.dialogForm);
    },
    handleSizeChange1(limit) { //表单条数
      this.dialogForm.page_size = limit;
      this.dialogForm.page = 1;
      this.getDialogData(this.dialogForm);
    },
    //表单搜索
    handleSearch1(dialogForm) {
      dialogForm.page = 1;
      this.getDialogData(dialogForm);
    },
    //表单重置
    handleSearch2(dialogForm) {
      dialogForm.page = 1;
      dialogForm.mobile_phone = '';
      dialogForm.user_name = '';
      this.getDialogData(dialogForm);
    },
    //表单获取数据
    getDialogData(params) { //初始化数据
      this.loading1 = true;
      this.$api.post("/api/agent/getUserAgent?page=" + params.page, params, res => {
        if (res.status == 200) {
          let dialogData = res.data;
          this.dialogTotal = dialogData.total; //总数
          this.dialogData = dialogData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading1 = false;
      })
    },
    //获取每行
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = row;
    },
    //取消
    cancelClick() {
      this.checkList = [];
      this.templateSelection = '';
    },
    //搜索用户弹框 
    handleSearchUser(ident) {
      this.ident = ident;
      this.agentVisible = true;
    },
    //更改组件状态 
    changeAgentVisible(agentVisible) {
      this.agentVisible = agentVisible;
    },
    //获取选中项 
    setSelectAgent(params) {
      switch (params.ident) {
        case 'yy': //运营中心 
          this.enquiryForm.operation_center = params.item ? params.item.id : '';
          this.enquiryForm.operation_center_name = params.item ? params.item.user_name : '';
          break;
        case 'su': //所属 
          this.enquiryForm.parent_id = params.item ? params.item.id : '';
          this.enquiryForm.parent_name = params.item ? params.item.user_name : '';

          break;
        case 'user': //下单人 
          this.enquiryForm.user_id = params.item ? params.item.id : '';
          this.enquiryForm.user_name = params.item ? params.item.user_name : '';
          break;
      }
      this.enquiryForm.page = 1;
      this.getData(this.enquiryForm);
    },
    // 产品选择表单部分
    //表单分页
    handleCurrentChange2(page) { //当前选中页
      this.dialogForm2.page = page;
      this.getDialogData2(this.dialogForm2);
    },
    handleSizeChange2(limit) { //表单条数
      this.dialogForm2.page_size = limit;
      this.dialogForm2.page = 1;
      this.getDialogData2(this.dialogForm2);
    },
    //表单获取数据
    getDialogData2(params) { //初始化数据
      this.loading2 = true;
      this.$api.post("/api/goods/goodsList?page=" + params.page, params, res => {
        if (res.status == 200) {
          let dialogData = res.data;
          this.dialogTotal2 = dialogData.total; //总数
          this.dialogData2 = dialogData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading2 = false;
      })
    },
    //获取每行
    singleElection2(row) {
      this.templateSelection2 = row.id;
      this.checkList2 = row;
    },
    //取消
    cancelClick2() {
      this.checkList2 = [];
      this.templateSelection2 = '';
    },
    //表单重置
    handleSearch3(dialogForm) {
      dialogForm.page = 1;
      dialogForm.merch_name = '';
      dialogForm.user_name = '';
      this.getDialogData2(dialogForm);
    },

    // 发货表单部分
    // 发货表单显示
    frozenInfo(row) {
      this.dialogFormVisible = true;
      this.form.id = row.id;
    },
    //确定
    confirmShipment(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.post("/api/Order/orderSend", this.form, res => {
            if (res.status == 200) {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
            this.clear();
            //渲染结束后取消加载
            this.dialogFormVisible = false;
          })
        } else {
          return false;
        }
      });
    },
    //取消
    clearShipment() {
      this.clear();
      //渲染结束后取消加载
      this.dialogFormVisible = false;
    },
    //发货表单清空
    clear() {
      this.form.delivery_from = '';
      this.form.delivery_order = '';
      this.form.order_remark = '';
    },

    //下拨部分
    //下拨表单显示
    thawInfo(row) {
      this.dialogDownVisible = true;
      this.downForm.order_id = row.id;
      this.downForm.user_id = row.user_id;
    },
    //下拨取消
    clearShipment2() {
      this.downClear();
      this.dialogDownVisible = false;
    },
    //下拨清空
    downClear() {
      this.downForm.user_id = '';
      this.downForm.order_id = '';
      this.downForm.end_device_code = '';
      this.downForm.start_device_code = '';
      this.downForm.transfer_quantity = '';
    },
    //下拨确定
    confirmShipment2(formName) {
      //获取=台数
      if (this.downForm.start_device_code !== '' && this.downForm.end_device_code !== '') {
        let formNum = {
          start_device_code: this.downForm.start_device_code,
          end_device_code: this.downForm.end_device_code
        }
        this.$api.post("/api/machine/getMachineNum", formNum, res => {
          if (res.status == 200) {
            this.downForm.transfer_quantity = res.data;
            //下拨
            this.$api.post("/api/machine/forceAllot", this.downForm, res => {
              if (res.status == 200) {
                this.$message.success(res.msg);
              } else {
                this.$message.error(res.msg);
              }
              this.downClear();
              //渲染结束后取消加载
              this.dialogDownVisible = false;
            })
            this.$message.success(res.msg);
          } else {
            this.downForm.transfer_quantity = '';
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            return false;
          } else {
            return false;
          }
        });
      }
      // 下拨
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     this.$api.post("/api/machine/forceAllot" ,this.downForm, res => {
      //       if (res.status == 200) {
      //         this.$message.success(res.msg);
      //       } else {
      //         this.$message.error(res.msg);
      //       }
      //       this.downClear();
      //       //渲染结束后取消加载
      //       this.dialogDownVisible=false;
      //     })
      //   } else {
      //     return false;
      //   }
      // });
    }
  }
}
</script>

<style scoped>
/deep/ .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

/deep/ .el-date-editor--datetimerange {
  height: 36px;
  width: 510px;
}

.code {
  cursor: pointer;
}

.code:hover {
  color: blue;
  text-decoration: underline;
}</style>
